module.exports = {"api":{"baseUrl":"https://admin.neofect.net/admin/api"},"stripeKey":"pk_live_NozIZffOo0XAJNDx3cq95HOQ"}


//////////////////
// WEBPACK FOOTER
// ./config/config.prod.json
// module id = 397
// module chunks = 0